import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { empleadosAPI } from '../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import '../Clientes.css';

const EmpleadoForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  useAuth();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    fecha_nacimiento: '',
    sueldo: '',
    activo: true
  });

  const esEdicion = Boolean(id);

  const loadEmpleado = useCallback(async () => {
    try {
      const response = await empleadosAPI.getById(id);
      if (response.success) {
        const d = response.data;
        setFormData({
          nombre: d.nombre || '',
          telefono: d.telefono || '',
          fecha_nacimiento: d.fecha_nacimiento ? d.fecha_nacimiento.slice(0, 10) : '',
          sueldo: d.sueldo != null && d.sueldo !== '' ? String(d.sueldo) : '',
          activo: d.activo !== false
        });
      }
    } catch (error) {
      toast.error('Error al cargar empleado');
      navigate('/empleados');
    }
  }, [id, navigate]);

  useEffect(() => {
    if (esEdicion) loadEmpleado();
  }, [esEdicion, loadEmpleado]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.nombre.trim()) {
      toast.error('El nombre es obligatorio');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        nombre: formData.nombre.trim(),
        telefono: formData.telefono.trim() || null,
        fecha_nacimiento: formData.fecha_nacimiento || null,
        sueldo: formData.sueldo !== '' ? parseFloat(formData.sueldo) : null,
        activo: formData.activo
      };
      if (esEdicion) {
        const response = await empleadosAPI.update(id, payload);
        if (response.success) {
          toast.success('Empleado actualizado');
          navigate('/empleados');
        }
      } else {
        const response = await empleadosAPI.create(payload);
        if (response.success) {
          toast.success('Empleado creado');
          navigate('/empleados');
        }
      }
    } catch (error) {
      toast.error(error.message || 'Error al guardar');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="clientes">
      <div className="page-header">
        <h1>{esEdicion ? 'Editar empleado' : 'Nuevo empleado'}</h1>
        <button type="button" onClick={() => navigate('/empleados')} className="btn-secondary">Volver</button>
      </div>

      <form onSubmit={handleSubmit} className="form-container" style={{ maxWidth: 500 }}>
        <div className="form-group">
          <label>Nombre *</label>
          <input
            type="text"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            required
            placeholder="Nombre completo"
            style={{ width: '100%', padding: '10px' }}
          />
        </div>
        <div className="form-group">
          <label>Teléfono</label>
          <input
            type="text"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            placeholder="Teléfono"
            style={{ width: '100%', padding: '10px' }}
          />
        </div>
        <div className="form-group">
          <label>Fecha de nacimiento</label>
          <input
            type="date"
            name="fecha_nacimiento"
            value={formData.fecha_nacimiento}
            onChange={handleChange}
            style={{ padding: '10px' }}
          />
        </div>
        <div className="form-group">
          <label>Sueldo</label>
          <input
            type="number"
            name="sueldo"
            value={formData.sueldo}
            onChange={handleChange}
            step="0.01"
            min="0"
            placeholder="0"
            style={{ width: '100%', padding: '10px' }}
          />
        </div>
        <div className="form-group">
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              type="checkbox"
              name="activo"
              checked={formData.activo}
              onChange={handleChange}
            />
            Activo
          </label>
        </div>
        <div className="form-actions" style={{ marginTop: 16 }}>
          <button type="button" onClick={() => navigate('/empleados')} className="btn-secondary">Cancelar</button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? 'Guardando...' : (esEdicion ? 'Guardar cambios' : 'Crear empleado')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EmpleadoForm;
